import React, { useContext } from "react";
import Products from "./products";
import { resultsFlattener } from "./productQueries";
import { Context } from "../../context";
const Woocommerceallproducts = (props) => {
    const context = useContext(Context);
    const { attributes } = props;
    const { allProducts } = context.wc;
    const total = (attributes.rows || 3) * (attributes.columns || 3);
    const products = resultsFlattener(allProducts).results.slice(0, total);
    //il faut créer un composant dédié pour les filtres.
    //celui-ci sera capable de récupérer tous les "attributs" permettant de filtrer : catégorie, attribut, tag, prix, etc.
    //il s'appuie sur une query statique pour avoir tout ce qu'il faut.
    //en fonction de la props passée, on affiche le type de filtre souhaité
    //on a donc différents rendus pour chaque type
    //les filtres sont stockés dans REDUX de façon à pouvoir revenir là où on en était dans la navigation.
    //on va utiliser suspense ou équivalent pour le chargement différé
    return React.createElement(Products, { ...props, products: products });
};
export default Woocommerceallproducts;
